// extracted by mini-css-extract-plugin
module.exports = {"container":"vL","hide":"vM","content":"vN","close":"vO","closeIcon":"vP","svgStyles":"vQ"};